import React, { useState } from 'react'

import {
    useHistory
} from 'react-router-dom'

import { 
    Div
} from '../../Styles/BaseStyles'

import { 
    HowContainerDiv,
    HowContainerContentsDiv,
    HowContentsDiv,
    HowRowContents,
    HowLeftContent,
    HowRightContent,
    HowSectionHeader,
    HowDetailsSection,
    HowDetails,
    HowStepsContainer,
    HowSteps,
    CollapseButton,
    ExpandButton,
    InlineLink 
} from '../../Styles/Components/HowStyles'

function How(props) {
    var history = useHistory()

    const [hideData, setHideData] = useState({
        hide1: true,
        hide2: true,
        hide3: true,
        hide4: true,
    })

    function toggleHide(num) {
        setHideData({
            ...hideData,
            [`hide${num}`]: !hideData[`hide${num}`]
        })
    }

    function signUpTransition() {
        history.push('/signup')
    }

    function logInTransition() {
        history.push('/login')
    }

    function downloadExtension() {
        history.push('/extension')
    }

    function openExtensionSettings() {
        let url = 'chrome://extensions/'
        
        window.open(
            url,
            '_blank'
        )
    }

    return (
        <HowContainerDiv id="how-section"> 
            <HowContainerContentsDiv>
                <HowContentsDiv>
                    <HowSectionHeader>How to use QuickFiller</HowSectionHeader>
                    <Div className="steps">
                        <HowRowContents>
                            <HowLeftContent>
                                <HowStepsContainer>
                                    <HowSteps>1. Create an Account and Log in</HowSteps>
                                    {hideData.hide1 ? <ExpandButton onClick={() => toggleHide(1)}/> : <CollapseButton onClick={() => toggleHide(1)}/>}
                                </HowStepsContainer>
                                {!hideData.hide1 && 
                                    <HowDetailsSection>
                                        <HowDetails>&#8594;Create an account <InlineLink onClick={signUpTransition}>here</InlineLink></HowDetails>
                                        <HowDetails>&#8594;Log in to your account <InlineLink onClick={logInTransition}>here</InlineLink></HowDetails>
                                    </HowDetailsSection>
                                }
                            </HowLeftContent>
                            <HowRightContent>
                                <HowStepsContainer>
                                    <HowSteps>2. Fill application forms</HowSteps>
                                    {hideData.hide2 ? <ExpandButton onClick={() => toggleHide(2)}/> : <CollapseButton onClick={() => toggleHide(2)}/>}
                                </HowStepsContainer>
                                {!hideData.hide2  && 
                                    <HowDetailsSection>
                                        <HowDetails>&#8594;Only job applications/resumes are available</HowDetails>
                                    </HowDetailsSection>
                                }
                            </HowRightContent>
                        </HowRowContents>
                        <HowRowContents>
                            <HowLeftContent>
                                <HowStepsContainer>
                                    <HowSteps>3. Download the extension and add it to your browser</HowSteps>
                                    {hideData.hide3 ? <ExpandButton onClick={() => toggleHide(3)}/> : <CollapseButton onClick={() => toggleHide(3)}/>}
                                </HowStepsContainer>
                                {!hideData.hide3 && 
                                    <HowDetailsSection>
                                        <HowDetails>&#8594;Download the extension <InlineLink onClick={downloadExtension}><strong>here</strong></InlineLink> and unzip the zip file contents&#42;</HowDetails>
                                        <HowDetails>&#8594;Go to <strong>chrome://extensions/</strong></HowDetails>
                                        <HowDetails>&#8594;Click <strong>Load Unpacked</strong>, the file system navegator will pop up</HowDetails>
                                        <HowDetails>&#8594;Select the folder that was unzipped from the zip file and the extension should show up in the browser toolbar</HowDetails><br />
                                        <HowDetails>&#42;The extension is only available for chromium browsers</HowDetails>
                                    </HowDetailsSection>
                                }
                            </HowLeftContent>
                            <HowRightContent>
                                <HowStepsContainer>
                                    <HowSteps>4. Use the extension to fill applications quicker</HowSteps>
                                    {hideData.hide4 ? <ExpandButton onClick={() => toggleHide(4)}/> : <CollapseButton onClick={() => toggleHide(4)}/>}
                                </HowStepsContainer>
                                {!hideData.hide4 && 
                                    <HowDetailsSection>
                                        <HowDetails>&#8594;Log in to the extension with your credentials</HowDetails>
                                        <HowDetails>&#8594;Fill job applications with the extension manual mode&#42;</HowDetails><br />
                                        <HowDetails>&#42;The extension only has manual mode enabled</HowDetails>
                                    </HowDetailsSection>
                                }
                            </HowRightContent>
                        </HowRowContents>
                    </Div>
                </HowContentsDiv>

            </HowContainerContentsDiv>
        </HowContainerDiv>
    )
}

export default How;